import React from 'react';

import {
    InputMediaStreamContext,
    useInputDiagnosticMicStream,
} from '../../../../../../hooks/use-diagnostic-mic-stream';
import { Island } from '../../../../island';
import { JoinWithMicrophoneOffTumbler } from '../../../../tumblers';
import { InputDeviceSelect } from '../../sound-supported/input-device-select';
import css from '../styles.css';
import { InputDeviceHeader } from './input-device-header';

export const InputDeviceSection = () => {
    const mediaInputStream = useInputDiagnosticMicStream();
    return (
        <Island className={css.soundWrapper}>
            <InputMediaStreamContext.Provider value={mediaInputStream}>
                <InputDeviceHeader />
                <InputDeviceSelect />
                <JoinWithMicrophoneOffTumbler />
            </InputMediaStreamContext.Provider>
        </Island>
    );
};
